import { makeObservable, observable, flow, computed } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

export default class InventoryDashboardStore {
  loading = false;
  models = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      models: observable,
      highlightedModels: computed,
      otherModels: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get highlightedModels() {
    return this.models.filter((m) => m.isHighlighted);
  }

  get otherModels() {
    return this.models.filter((m) => !m.isHighlighted);
  }

  *load(params = {}) {
    try {
      this.loading = true;

      // Ensure OOB models exist for this tenant
      yield api.post(ApiRoutes.forEnsureDefaults());

      // Load models with filters
      const response = yield api.post(ApiRoutes.forModelSearch(), {
        search: params.search ?? "",
        query: params.query,
        sort: params.sort ?? [{ property: "name", asc: true }],
        page: params.page ?? 1,
        pageSize: 100,
      });

      if (response.status === 200) {
        this.models = response.data.items;
        return { success: true, data: response.data };
      }
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
